module.exports = __webpack_public_path__ + "d2122177b4eca62b98a66635b2c559bf.png";